import React from 'react';
import { Reveal } from './Reveal';
import { ArrowRight } from 'lucide-react';
const comparisons = [{
  notebook: 'Você anota tudo',
  boutique: 'Você diz, ele calcula'
}, {
  notebook: 'Esquece o que esqueceu',
  boutique: 'Lembra de tudo por você'
}, {
  notebook: 'Material subiu = refazer tudo',
  boutique: 'Material subiu = se ajusta sozinho'
}, {
  notebook: 'Você não sabe se tá lucrando',
  boutique: 'Você abre e vê o lucro'
}, {
  notebook: 'Fica em cima da geladeira',
  boutique: 'Fica no seu bolso'
}];
export function ComparisonSection() {
  return <section className="py-12 md:py-16 px-[5vw] bg-bg" data-id="element-31">
      <div className="max-w-4xl mx-auto" data-id="element-32">
        <Reveal data-id="element-33">
          <div className="text-center mb-10" data-id="element-34">
            <h2 className="font-serif font-bold text-[22px] md:text-[clamp(28px,3.5vw,40px)] tracking-[-0.02em] text-ink mb-4 leading-tight max-w-3xl mx-auto" data-id="element-35">
              Você já tentou planilha. Já tentou caderno. Já tentou na cabeça.{' '}
              <span className="font-caveat text-rose" data-id="element-36">
                Por que dessa vez vai ser diferente?
              </span>
            </h2>
            <p className="text-[15px] md:text-[17px] leading-[1.6] text-ink-soft max-w-2xl mx-auto" data-id="element-37">
              Porque o Aurora não é mais uma coisa pra você fazer.{' '}
              <strong className="text-ink font-semibold" data-id="element-38">
                É uma coisa que faz por você.
              </strong>
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.1} data-id="element-39">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-40">
            {/* Caderno/Planilha Column */}
            <div className="bg-white border border-line rounded-[20px] p-5 md:p-6" data-id="element-41">
              <div className="flex items-center gap-2 mb-5" data-id="element-42">
                <span className="text-xl" data-id="element-43">📓</span>
                <h3 className="font-serif font-bold text-base text-ink-soft" data-id="element-44">
                  Caderno / Planilha
                </h3>
              </div>
              <div className="space-y-3" data-id="element-45">
                {comparisons.map((item, i) => <div key={i} className="flex items-center gap-3 py-2.5 px-3 rounded-xl bg-[#f5f0eb]/60" data-id="element-46">
                    <span className="text-ink-soft/40 text-sm" data-id="element-47">✗</span>
                    <span className="text-[14px] text-ink-soft leading-snug" data-id="element-48">
                      {item.notebook}
                    </span>
                  </div>)}
              </div>
            </div>

            {/* Aurora Column */}
            <div className="bg-rose-soft/40 border-2 border-rose rounded-[20px] p-5 md:p-6" data-id="element-49">
              <div className="flex items-center gap-2 mb-5" data-id="element-50">
                <span className="text-xl" data-id="element-51">🌸</span>
                <h3 className="font-serif font-bold text-base text-ink" data-id="element-52">
                  Aurora
                </h3>
              </div>
              <div className="space-y-3" data-id="element-53">
                {comparisons.map((item, i) => <div key={i} className="flex items-center gap-3 py-2.5 px-3 rounded-xl bg-white/70" data-id="element-54">
                    <span className="text-rose text-sm" data-id="element-55">✓</span>
                    <span className="text-[14px] text-ink font-medium leading-snug" data-id="element-56">
                      {item.boutique}
                    </span>
                  </div>)}
              </div>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.2} data-id="element-57">
          <div className="text-center mt-8" data-id="element-58">
            <a href="#preco" className="inline-flex items-center gap-3 bg-ink text-white pl-8 pr-2 py-2.5 rounded-full hover:bg-ink/90 transition-all hover:scale-105 no-underline" data-id="element-59">
              <span className="font-medium" data-id="element-60">Quero parar de chutar</span>
              <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center" data-id="element-61">
                <ArrowRight size={18} className="text-white" data-id="element-62" />
              </div>
            </a>
          </div>
        </Reveal>
      </div>
    </section>;
}